import React, { Fragment } from "react";

import { Testimonial } from "../../data/partners";
import HubspotLetsTalkForm from "../hubspot_lets_talk_form";
import testimonial1Src from "../images/testimonial-1.png";
import testimonial2Src from "../images/testimonial-2.png";
import testimonial3Src from "../images/testimonial-3.png";
import testimonial4Src from "../images/testimonial-4.png";
import testimonial5Src from "../images/testimonial-5.png";
import testimonial6Src from "../images/testimonial-6.png";
import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { Text } from "../text";
import { useMindspaceAnalytics } from "./mindspace_analytics";
import { partnerConfig } from "./mindspace_partner_config";
import { lazyWithRetry } from "../../core/lazy_with_retry";

const Theme = lazyWithRetry(() => import("./mindspace_theme"));

const faqs = [
  {
    question: "Do I need to book in advance?",
    answer:
      "You will need to book ahead of arriving in order to secure your desk. When possible, we will accommodate walk-ins according to availability.",
  },

  {
    question: "Can I roll over any unused entries into the next month?",
    answer:
      "Mindpass Daily is valid for your booked date only and cannot be rolled over into the following month. ",
  },

  {
    question: "Can I cancel my day pass purchase?",
    answer: " Mindpass daily is non-refundable.",
  },

  {
    question:
      "I accidentally booked for the wrong date; can I modify my booking?",
    answer:
      "Yes. Please contact our support and we will assist in modifying your order.",
  },

  {
    question: "Can I share my Mindpass with other people?",
    answer:
      "Your Mindpass Daily is personal and cannot be transferred to someone else or shared with anyone. ",
  },

  {
    question: "Can I use the meeting rooms?",
    answer:
      "If you would like to use a meeting room, you will need to rent out a meeting room separately. Please contact our staff for availability and pricing options.",
  },

  {
    question: "Can I use the printer?",
    answer:
      "If you have something urgent that needs printing, please approach the front deck and we will assist you.",
  },

  {
    question:
      "Can I meet with clients or bring a guest into the Mindspace lounges and communal area?",
    answer:
      "Your Mindpass Daily is individual and doesn’t cover guests. To secure access for a guest, simply ask them to complete the same purchase process or complete it for them. For private meetings, you can book a meeting room based on availability.",
  },
];

const testimonials: Testimonial[] = [
  {
    testimonial:
      "What I like the most about Mindspace is the good exchange we can have here with a lot of different companies and young minds. Seriousness on the one hand, young and vital on the other.",
    companyTitle: "Director Corporate Affairs at Samsung",
    name: "Steffen Ganders",
    companyLogo: testimonial5Src,
  },
  {
    testimonial:
      "My Berlin centrepiece of living is probably 20-25 min around Mindspace. What feels like living in a village where Mindspace plays a big role.",
    companyTitle: "Strategic Investments",
    name: "Carl-Luis Rieger",
    companyLogo: testimonial1Src,
  },
  {
    testimonial:
      "We love Mindspace. It is one of the best things that our company ever did for us.",
    companyTitle: "Group Creative Director",
    name: "Vanessa Roberts",
    companyLogo: testimonial2Src,
  },
  {
    testimonial:
      "The impeccable design and the productive work atmosphere at Mindspace led us to relocate our very own Berlin team to the Mindspace location in our building, a decision we are extremely happy about.",
    companyTitle: "Senior Director Development & Leasing",
    name: "Peter Roers",
    companyLogo: testimonial3Src,
  },
  {
    testimonial:
      "The thing that I love about Mindspace is basically: you sign a contract, you get the key, you open your door and you can start working from the second you enter your room. It is really right away and that is amazing.",
    companyTitle: "Founder of MBRC The Ocean GmbH",
    name: "Sven Jacobi",
    companyLogo: testimonial4Src,
  },
  {
    testimonial:
      "“When I walk into Mindspace, I just wake up, because of this energy that I can’t really tangibly grasp, but there is something about it that sets my mood and the attitude for the day,",
    companyTitle: "Sales at Kizen",
    name: "Hanna Jung",
    companyLogo: testimonial6Src,
  },
];

export function OfferingMindspaceMultiPass() {
  useMindspaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections={false}
        partnerConfig={{
          ...partnerConfig,
          hubspotForm: (
            <HubspotLetsTalkForm
              portalId="5264364"
              formId="10bed070-52fd-436e-b1c6-3bf15047acc1"
            />
          ),
        }}
        data={{
          description: (
            <Fragment>
              <p>
                <Text>
                  Mindpass Multi is a location-specific pass for 4, 8, or 12
                  entries a month between 9am and 6pm on business days. Enjoy
                  the full Mindspace membership benefits (Happy Hour, wellness
                  programs, events, etc.) while working from a professional and
                  inspiring environment. Easily mix work from home and in-office
                  with your own desk in a shared office or a designated area.
                </Text>
              </p>
              <p>
                <Text>
                  Mindpass Multi is a personal, non-transferable access card{" "}
                  <strong>valid for 30 days</strong> from the date of purchase.
                </Text>
              </p>
            </Fragment>
          ),
          amenitiesDescription:
            "Our community management team is available to help with any requests or administrative services needed.",
          faqs,
          testimonials: testimonials,
          generalInfo: {
            title: "Health & safety",
            description: `At Mindspace, we are committed to delivering both an exceptional service and a safe workspace for our members:`,
            bulletPoints: [
              {
                text: "Offices and workstations are cleaned and sanitized on a frequent basis",
              },
              {
                text: "All Mindspace workspaces are in line with the safety rules and guidelines of the “Mindspace Seal”",
              },
            ],
          },
        }}
      />
    </Fragment>
  );
}
